import { render, staticRenderFns } from "./welcomeWeChatdialog.vue?vue&type=template&id=b3fb6218&scoped=true"
import script from "./welcomeWeChatdialog.vue?vue&type=script&lang=js"
export * from "./welcomeWeChatdialog.vue?vue&type=script&lang=js"
import style0 from "./welcomeWeChatdialog.vue?vue&type=style&index=0&id=b3fb6218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fb6218",
  null
  
)

export default component.exports